module.exports = __webpack_public_path__ + "img/logo déguster.cb3ad889.png";